export const version = "4.7.0";
export const navbarBreakPoint = "xl"; // Vertical navbar breakpoint
export const topNavbarBreakpoint = "lg";
export const themeVariants = ["light", "dark", "auto"];
export const settings = {
  isFluid: true,
  isRTL: false,
  isDark: false,
  theme: "light",
  navbarPosition: "vertical",
  showBurgerMenu: false, // controls showing vertical nav on mobile
  currency: "$",
  isNavbarVerticalCollapsed: true, // toggle vertical navbar collapse
  navbarStyle: "transparent",
  disabledNavbarPosition: ["Top"], // disabled navbar position
};

export default { version, navbarBreakPoint, topNavbarBreakpoint, settings };
